import React from "react";
import styled from "styled-components";

import { ReactComponent as CancelledIcon } from "../../../../assets/icons/RedCancelButton.svg";
import { ReactComponent as DoneIcon } from "../../../../assets/icons/GreenDoneButton.svg";
import {
    StatusSubprocess,
    getLabelStatusSubprocessEnum,
} from "../../../../model/Enums/StatusSubprocessEnum";

const Pill = styled.div.attrs((props: { color: string; size: string }) => ({
    color: props.color,
    size: props.size,
}))`
    background-color: ${(props) => props.color};
    color: #1e1e1e;
    padding: 16px 20px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;
    min-width: ${(props) => props.size};

    svg {
        margin-right: 16px;
    }
`;

interface IStatusPillProps {
    status?: string;
}

const StatusPill: React.FC<IStatusPillProps> = ({ status = "" }) => {
    const approvedStatus = [
        StatusSubprocess.DONE,
        StatusSubprocess.WAITING_APPROVAL,
    ].includes(status.toUpperCase() as StatusSubprocess);

    const pendingStatus = [StatusSubprocess.PENDING].includes(
        status.toUpperCase() as StatusSubprocess
    );

    const pillText = approvedStatus
        ? "Finalizado"
        : getLabelStatusSubprocessEnum(status as StatusSubprocess);

    return !pendingStatus && status.length ? (
        <Pill color={approvedStatus ? "#EAFFD9" : "#FFE0E0"} size="146px">
            {approvedStatus ? <DoneIcon /> : <CancelledIcon />}
            {pillText}
        </Pill>
    ) : null;
};

export default StatusPill;
